import { rest } from "msw";
import type { CustomAttributeServiceType } from "../adapters/CustomAttributesDomain.ts";
import type { DomainConfig } from "../config.ts";
import { AssetType } from "../schemas/AssetSchemas.ts";
import { AttributeDataType } from "../schemas/AttributeSchemas.ts";
import {
  CustomAttributeSchema,
  type CustomAttributeType,
} from "../schemas/CustomAttributeSchemas.ts";
import {
  getApiUrlWithEndpoint,
  type BuildMockHandlersType,
} from "./handlers.ts";
import { DomainFaker, DomainMock } from "./utils.ts";

export const CustomAttributeMock = new DomainMock<
  CustomAttributeType,
  typeof CustomAttributeSchema
>(
  CustomAttributeSchema,
  () => {
    const createdAt = DomainFaker.en.date.past();

    return {
      archived: DomainFaker.en.helpers.arrayElement([true, false]),
      company_id: DomainFaker.en.string.uuid(),
      display_name: DomainFaker.en.string.alpha(10),
      entity_type: DomainFaker.en.helpers.arrayElement([
        AssetType.EQUIPMENT,
        AssetType.DEVICE,
        AssetType.FACILITY,
        AssetType.FLOW,
        AssetType.ASSET_GROUP,
      ]),
      field_name: DomainFaker.en.string.alpha(10),
      data_type: DomainFaker.en.helpers.arrayElement(
        Object.values(AttributeDataType)
      ),
      description: DomainFaker.en.string.alpha(10),
      is_required: DomainFaker.en.helpers.arrayElement([true, false]),
      created_at: createdAt.toISOString(),
      updated_at: DomainFaker.en.date
        .between({ from: createdAt, to: new Date() })
        .toISOString(),
    };
  },
  true
).fix();

export const buildCustomAttributeHandlers: BuildMockHandlersType<
  CustomAttributeServiceType
> = (configData: DomainConfig) => {
  const { nodeURL: url } = configData;
  const entity_type = AssetType.DEVICE;

  return {
    getList: rest.get(
      getApiUrlWithEndpoint({
        url,
        version: 1,
        endpoint: `/custom_attribute_definition/${entity_type}`,
      }),
      (req, res, ctx) => {
        const page = Number(req.url.searchParams.get("page"));
        const pageSize = Number(req.url.searchParams.get("pageSize"));
        const data = new Array(5)
          .fill(0)
          .map(() => CustomAttributeMock.generate());

        return res(
          ctx.status(200),
          ctx.json({
            data,
            page_number: page,
            page_size: pageSize,
            total_entries: data.length,
            total_pages: 1,
          })
        );
      }
    ),
  };
};
